<template>
	<v-dialog
		v-model="showLocal"
		max-width="450"
		@click:outside="hideDialog"
	>
		<v-card class="dialogCreateUser">
			<progress-bar :isLoading="dataIsLoading"></progress-bar>
			<v-card-title class="headline">{{txt.title}}</v-card-title>
			<div class="formEdit">
				<v-form>
					<v-text-field
						v-model="createdUser.firstname"
						:label="txt.label.firstName"
					/>
					<v-text-field
						v-model="createdUser.lastname"
						:label="txt.label.lastName"
					/>
					<v-text-field
						v-model="createdUser.username"
						:label="txt.label.email"
					/>
					<div> {{txt.reminder}} </div>
					<v-btn
						color="green"
						class="button"
						outlined
						@click="createNewUser"
					>
						<v-icon>mdi-check</v-icon>
						{{txt.btn.submit}}
					</v-btn>

					<v-btn
						class="button"
						color="secondary"
						outlined
						@click="hideDialog"
					>{{txt.btn.cancel}}
					</v-btn>
				</v-form>
			</div>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from 'axios'
import ProgressBar from '../../vueBasics/Progressbar.vue'

export default {
	name: 'CreateNewUser',
	components: {
		ProgressBar,
	},
	props: {
		show: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			txt: {
				reminder: `Reminder: The credentials are sent 
					directly to the user and no rights are initially assigned.`,
				title: 'Create user',
				btn: {
					submit: 'Submit changes',
					cancel: 'Cancel',
				},
				label: {
					firstName: 'First Name',
					lastName: 'Last Name',
					email: 'Email',
				},
			},
			createdUser: {},
			showLocal: this.show,
			dataIsLoading: false,
		}
	},
	methods: {
		hideDialog() {
			this.showLocal = false
			this.$emit('changeShowDialog', false)
		},
		async createNewUser() {
			try {
				this.dataIsLoading = true
				const r = await axios.post(config.baseAPIurl + '/user-manager/user',
					{ user: this.createdUser },
				)
				const userCredentialsResponse = r.data.userCredentials
				this.createdUser.password = userCredentialsResponse.password
				await axios.post(config.baseAPIurl + '/user-manager/email-user-data',
					{
						user: this.createdUser,
						url: window.location.origin,
					},
				)
				this.$emit('userCreated')
				this.$emit(
					'userCreationFinalized',
					`User created successfully, credentials sent to ${this.createdUser.username}`
				)
			} catch (error) {
				this.$emit('errorOccured', error)
			} finally {
				this.hideDialog()
				this.dataIsLoading = false
			}
		},
	},
}
</script>

<style scoped>

.dialogCreateUser {
	padding: 30px;
}

.button {
	margin: 10px;
	margin-top: 25px
}

</style>
Progressbar